export const getAriaAttr = (value: boolean | undefined) =>
  value ? true : undefined
